<template>
    <dash
        icon="fa fa-book"
        titulo="PROJETOS SGTEC"
        subTitulo="GERENTE"
        @click.native="$router.push({ name: 'Sgtec_Gerentes_Projetos' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
